export default __webpack_public_path__ + "static/media/Inter-UI-Bold.d9ae3c47.woff";